import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { select } from 'd3-selection';
import { CaliperViewModel } from '../../view-models/caliper-viewmodel';
import { EcgMeasuresService } from '../../utils/ecg-measures.service';
import { EcgMeasures } from '../../models/ecgmeasures';
import { Layout } from '../../layout/layout';
import { WindowComponent } from './window/window.component';
import { PointerComponent } from './pointer/pointer.component';

@Component({
    selector: '[trace-caliper]',
    templateUrl: './caliper.component.html',
    styleUrls: ['./caliper.component.css'],
    imports: [WindowComponent, PointerComponent],
    standalone: true,
})
export class CaliperComponent implements OnInit {
    // events

    @Output()
    removeCaliper = new EventEmitter<CaliperViewModel>();

    @Output()
    measuresChange = new EventEmitter<CaliperViewModel>();

    // data members

    constructor(
        private elementRef: ElementRef,
        private ecgMeasuresService: EcgMeasuresService,
        private layout: Layout,
    ) {}

    private _caliper!: CaliperViewModel;

    get caliper() {
        return this._caliper;
    }

    @Input()
    set caliper(caliper: CaliperViewModel) {
        this._caliper = caliper;
        this.updateMeasures();
    }

    private _measures!: EcgMeasures;

    // constructor

    get measures(): EcgMeasures {
        return this._measures;
    }

    // public functions

    ngOnInit() {
        select(this.elementRef.nativeElement)
            .on('click', (event) => {
                this.updateMeasures();

                event.stopPropagation();
            })
            .on('mouseover', () => {
                this.caliper.highlight = true;
            })
            .on('mouseout', () => {
                this.caliper.highlight = false;
            });

        select(this.elementRef.nativeElement)
            .select('#window')
            .on('click', (event) => {
                event.stopPropagation();
            });
    }

    onRemoveCaliper() {
        this.removeCaliper.emit(this.caliper);
    }

    onPositionChange(position: { x: number; y: number }) {
        this.caliper.setPositionX(position.x);
        this.updateMeasures();
    }

    onPointer1IntersectionChange() {
        this.updateMeasures();
    }

    onPointer2IntersectionChange() {
        this.updateMeasures();
    }

    // private functions

    updateMeasures() {
        this.caliper.window.update();
        this._measures = this.ecgMeasuresService.calculate(this.caliper, this.layout);
        this.caliper.updateMeasures(this._measures);
        this.measuresChange.emit(this.caliper);
    }
}
